import React, { useState } from 'react';
import { Modal, Radio, Button, Input } from 'antd';
import 'antd/dist/antd.css';
import './RejectModal.scss';
import { updateIssueStatus } from 'store/actions/IssuePanelActions';
import { connect } from 'react-redux';
import { ISSUE_STATUS, getFormattedTimestamp, formatToDateOnly } from '../constants';

const RejectionModal = ({
  rejectModalVisible,
  setrejectModalVisible,
  record,
  updateIssueStatus,
  toastVisible,
  setToastVisible,
  setToastText,
}) => {
  const REJECT_REASON = {
    NO_ISSUE_FOUND: 10,
    TOLERENCE_LEVEL: 20,
    OTHERS: 30,
  };
  const REJECT_REASON_REVERSE = {
    10: 'No issue found',
    20: 'Quantity is below the tolerance level',
    30: 'Others',
  };

  const [reason, setReason] = useState(REJECT_REASON.NO_ISSUE_FOUND);
  const [otherReason, setOtherReason] = useState('');
  const handleReject = () => {

    const inputs = {
      resolvedAt: getFormattedTimestamp(),
      issueStatus: ISSUE_STATUS.REJECTED,
      rejectionReason:
        reason === REJECT_REASON.OTHERS ? otherReason : REJECT_REASON_REVERSE[reason],
      issueData: { ...record },
    };
    updateIssueStatus(inputs)
    .then((res) => {
      if (res.success) {
        setToastText('Issue rejected successfully!');
        setToastVisible(true);
      }
    });
    setrejectModalVisible(false);
  };

  return (
    <Modal
      open={rejectModalVisible}
      onCancel={() => setrejectModalVisible(false)}
      closable={false}
      footer={null}
      centered
      className="rejection-modal"
      bodyStyle={{
        height: reason === REJECT_REASON.OTHERS ? '340px' : '270px',
        width: 'fit-content',
        padding: '24px',
        transition: '0.3s ease-in-out',
        borderRadius: '8px',
      }}>
      <div className="modal-title">Reason for rejection</div>

      <Radio.Group
        onChange={(e) => setReason(e.target.value)}
        value={reason}
        className="custom-radio-group"
        style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Radio
          value={REJECT_REASON.NO_ISSUE_FOUND}
          className={
            reason == REJECT_REASON.NO_ISSUE_FOUND ? 'radio-selected' : 'radio-unselected'
          }>
          No issue found
        </Radio>
        <Radio
          value={REJECT_REASON.TOLERENCE_LEVEL}
          className={
            reason == REJECT_REASON.TOLERENCE_LEVEL ? 'radio-selected' : 'radio-unselected'
          }>
          Quantity is below the tolerance level
        </Radio>
        <Radio
          value={REJECT_REASON.OTHERS}
          className={reason == REJECT_REASON.OTHERS ? 'radio-selected' : 'radio-unselected'}>
          Others
        </Radio>
      </Radio.Group>

      {reason === REJECT_REASON.OTHERS && (
        <Input.TextArea
          placeholder=""
          value={otherReason}
          onChange={(e) => setOtherReason(e.target.value)}
          rows={3}
          className="textarea-other"
        />
      )}

      <div className="modal-footer">
        <button className="btn-outline" onClick={() => setrejectModalVisible(false)}>
          Close
        </button>
        <button
          className={
            reason === REJECT_REASON.OTHERS && !otherReason.trim() ? 'btn-disabled' : 'btn-primary'
          }
          onClick={handleReject}
          disabled={reason === REJECT_REASON.OTHERS && !otherReason.trim()}>
          Reject
        </button>
      </div>
    </Modal>
  );
};
const mapStateToProps = (state) => ({
  activeIssueData: state.issuePanelData.activeIssueData,
});

const mapDispatchToProps = (dispatch) => ({
  updateIssueStatus: (data) => dispatch(updateIssueStatus(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RejectionModal);
